import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import "./GoToContainer.scss";
import { useTranslation } from "react-i18next";
import { BetaTag } from "../widgets";

interface IProps {
    title: string;
    text: string;
    onToggle: any;
    src?: string;
    betaVersion?: boolean;
    disabled?: boolean;
}

function GoToContainer(props: IProps) {
    const DisplayIcon = () => {
        return (
            <div className="arrowDiv" onClick={props.onToggle}>
                <FontAwesomeIcon icon={faArrowRight} className="arrow" />
            </div>
        );
    };

    const { t } = useTranslation();

    return (
        <div
            className={`goToContainer ${props.disabled ? "goToContainerDisabled" : ""}`}
            onClick={() => {
                if (props.disabled) return;
                props.onToggle();
            }}
        >
            <div className="containerDetailsDiv">
                {props.src && <img alt="alt" src={props.src} className="imageDiv" />}

                <div className="containerDetails">
                    <div className="containerHeader">{props.title}</div>
                    <div className="containerDes">{props.text}</div>
                </div>
            </div>
            <div className="betaContainer">
                {props.betaVersion && <BetaTag />}
                <DisplayIcon />
            </div>
        </div>
    );
}

export default GoToContainer;
